import { endOfDay, startOfDay } from "date-fns";
import React from "react";

import { CheckboxGroup, DateRangePicker, InputWrapper, RadioButtons } from "@performyard/py-components";

import FilterPanelBase from "../../../../components/Panel/FilterPanel";

import { capitalizeWord } from "../../../../utils/stringUtils";

import { config } from "../config";
import type { WorkspaceDetailsTableFilters } from "../schema";

type FilterPanelProps = {
	isOpen: boolean;
	onClose: () => void;
	onApplyFilters: (filters: WorkspaceDetailsTableFilters) => void;
	filters: WorkspaceDetailsTableFilters;
	updateForm: (newFilters: Partial<WorkspaceDetailsTableFilters>) => void;
};

const FilterPanel = ({
	isOpen,
	onClose,
	onApplyFilters,
	filters,
	updateForm,
}: FilterPanelProps): React.ReactElement => {
	const statusOptions = config.statusOptions.map((status) => ({
		value: status,
		label: capitalizeWord(status),
	}));

	const privateNotesRadioOptions = config.privateNotesOptions.map((option) => ({
		value: option,
		label: option === "any" ? "Any" : option === "has-private-notes" ? "Has Private Notes" : "No Private Notes",
	}));

	return (
		<FilterPanelBase
			isOpen={isOpen}
			onClose={onClose}
			title="Filters"
			onSaveFilters={() => {
				onApplyFilters(filters);
				onClose();
			}}
		>
			<InputWrapper id="status-filter" label="Status">
				<CheckboxGroup
					id="status-filter"
					options={statusOptions}
					value={filters?.status || []}
					onChange={(selectedStatuses) => {
						updateForm({ status: selectedStatuses });
					}}
				/>
			</InputWrapper>
			<div className="h-4" />
			<InputWrapper label="Meeting Date" id="meeting-date-filter">
				<DateRangePicker
					id="meeting-date-filter"
					value={{
						from: filters.meetingDateStart,
						to: filters.meetingDateEnd,
					}}
					onChange={(date) => {
						const fromDate = date?.from ? startOfDay(date.from) : undefined;
						const toDate = date?.to ? endOfDay(date.to) : undefined;

						updateForm({
							meetingDateStart: fromDate,
							meetingDateEnd: toDate,
						});
					}}
					popoverContentClassName="z-[1100]"
					menuAlign="start"
					hasClearButton
				/>
			</InputWrapper>
			<div className="h-4" />
			<InputWrapper id="private-notes-filter" label="Private Notes">
				<RadioButtons
					id="private-notes-filter"
					options={privateNotesRadioOptions}
					value={filters?.privateNotes || "any"}
					onChange={(selectedOption) => {
						updateForm({ privateNotes: selectedOption });
					}}
				/>
			</InputWrapper>
		</FilterPanelBase>
	);
};

export default FilterPanel;
